import React from 'react'
import useMuiCompontent from '../../../Hooks/useMuiCompontent'
import { Modal } from 'react-bootstrap'

const DeleteModal = ({ open = false, onHide = () => { }, handleDelete = () => { }, name = "" }) => {
    const { CustomButton } = useMuiCompontent()
    return (
        <>
            <Modal show={open} onHide={onHide} centered >
                <Modal.Body>
                    <div className="modal-body text-center cus-i">
                        <i className="fa-solid fa-trash-can all_icons_color"></i>
                        <p className="mb-0">Are you sure?</p>
                        <p>You want to delete this {name}</p>
                        <CustomButton variant="outlined" className="me-3 mt-3" onClick={() => handleDelete("NO")} >No</CustomButton>
                        <CustomButton variant="contained" className="mt-3" onClick={() => handleDelete("YES")} >Yes</CustomButton>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default DeleteModal
